<template>
	<div class="planning" v-if="planning">
		<div class="planning__header">
			<Icon
				:size="$mq === 'lg' ? null : 80"
				:header="true"
				:icon="planning.Info.icon">
			</Icon>
			<div class="planning__header__content">
				<h1 class="planning__header__title">
					<span class="planning__header__title--faint" v-if="$mq === 'lg'">
						Planning
					</span>
					{{planning.Info.title}}
					<button
						class="planning__replicate"
						v-if="!userHasPlanningForCourse"
						@click="replicatePlanning"
					>
						<i class="fas fa-paste"></i>
						Replicate
					</button>
					<router-link
						tag="button"
						class="planning__replicate"
						v-else-if="!userIsOwner"
						:to="`/planning/${this.planning.id}/merge`"
						@click="replicatePlanning"
					>
						<i class="fas fa-file-import"></i>
						Merge
					</router-link>
					<button
						class="planning__recommend"
						v-if="userIsSuper"
						@click="recommendPlanning(!planning.Recommended)"
					>
						<i class="fas fa-medal"></i>
						<span v-if="planning.Recommended">Remove 'Stipt Recommended'</span>
						<span v-else>Add 'Stipt Recommended'</span>
					</button>
				</h1>
				<router-link
					class="planning__edit"
					v-if="userIsOwner"
					:to="`/planning/edit/${this.planning.id}`">
					Edit planning
				</router-link>
				<button
					class="planning__delete"
					v-if="userIsOwner || userIsSuper"
					@click="deletePlanning"
				>
					<i class="fas fa-trash-alt"></i>
					Delete
				</button>
				<router-link
					v-if="!userIsOwner"
					tag="p"
					class="link"
					:to="`/profile/${planning.User.username}`">
					{{planning.User.username}}
				</router-link>
			</div>
		</div>
		<div class="planning__content">
			<ProgressBlocks
				@clearFilters="clearFilters"
				@setFilters="setFilters"
				v-if="userIsOwner"
				class="planning__progress-blocks"
				:tasks="planning.Tasks"
				:topics="planning.Topics">
			</ProgressBlocks>
			<div class="planning__tasks">
				<TasksPlanning
					:filters="filters"
					:planning="planning">
				</TasksPlanning>
			</div>
		</div>
	</div>
</template>

<script>
import AdminService from '@/services/AdminService'
import PlanningService from '@/services/PlanningService'
import Icon from '@/components/Icon'
import ProgressBlocks from '@/components/ProgressBlocks'
import TasksPlanning from '@/components/TasksPlanning'
require('@/services/DateFormatService')
export default {
	components: {
		Icon,
		ProgressBlocks,
		TasksPlanning
	},
	data () {
		return {
			filters: null,
			planning: null
		}
	},
	methods: {
		async getPlanning () {
			// Ensure plannings are always refreshed when a Planning is opened
			await this.$store.dispatch('getPlannings')
			const planningId = parseInt(this.$route.params.id)
			// Check if the planning exists amongst local plannings
			const plannings = this.$store.state.plannings
			if (plannings) {
				const index = plannings.findIndex(planning => planning.id === planningId)
				// If the user is the owner, get the planning from local storage
				if (index >= 0) {
					this.planning = plannings[index]
					return
				}
			}
			// The user is not the owner; grab the planning from the server
			this.planning = await PlanningService.get(planningId)
		},
		async deletePlanning () {
			if (confirm('Do you really want to delete this planning?')) {
				await PlanningService.delete(this.planning.id)
				// Update locally retrieved plannings
				await this.$store.dispatch('getPlannings')
				// After deletion, return to plannings
				this.$router.push(`/plannings`)
			}
		},
		async replicatePlanning () {
			await PlanningService.replicate(this.planning.id)
			// Update locally retrieved plannings
			await this.$store.dispatch('getPlannings')
			// After replication, go to plannings
			this.$router.push(`/plannings`)
		},
		async recommendPlanning (recommended) {
			await AdminService.recommendPlanning(recommended, this.planning.id)
			// Refresh the page
			this.$router.go()
		},
		clearFilters () {
			this.filters = null
		},
		setFilters (type, key) {
			const filters = {
				type,
				key
			}
			this.filters = filters
		}
	},
	computed: {
		userIsOwner () {
			return this.planning.User.id === this.$store.state.authentication.user.id
		},
		userIsSuper () {
			return this.$store.state.authentication.user.role === 'super'
		},
		userHasPlanningForCourse () {
			// Check if the user already has a planning for this course
			const plannings = this.$store.state.plannings
			if (plannings) return (plannings.findIndex(planning => planning.Info.Course.id === this.planning.Info.Course.id) >= 0)
			else return false
		}
	},
	watch: {
		async '$route' () {
			await this.getPlanning()
			this.clearFilters()
		}
	},
	async created () {
		await this.getPlanning()
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/views/_planning.scss";
</style>
